module.exports = __webpack_public_path__ + "static/media/spectator_logo.fbb7ed95.svg";